import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            热门分类
          </h2>
          <p className="mt-2 text-foreground-500 text-sm">
            韩漫、日漫、国漫，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comicCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 hover:bg-background-200 transition-colors p-6 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 rounded-xl bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500/20 transition-colors">
                  <i className={`${cat.icon} text-2xl text-primary-500`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-500 leading-relaxed">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-3 text-sm text-primary-500 font-medium">
                    浏览全部
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}